import request from '@/utils/request';


export const getList = (query) => {
	return request({
		url: '/proFileApi/customer/getService/exclusive',
		method: 'get',
		params: query,
		responseType: 'blob'
	})
}